import React from 'react'

const GroupAmount = ({ handleIncrease, handleDecrease, currentValue, disabled }) => {
    return (
        <div className="group-amount">
            <div onClick={() => !disabled && handleDecrease()} className="group-amount__decrease">
                <i className="fas fa-minus" />
            </div>
            <div className="group-amount__current">{currentValue}</div>
            <div onClick={() => !disabled && handleIncrease()} className="group-amount__increase">
                <i className="fas fa-plus" />
            </div>
        </div>
    )
}

export default GroupAmount
